<template>
  <div>
    <!-- Top Navigation -->
    <AppBar
      :companyNotifications="companyNotifications"
      :unreadCount="unreadCount"
      @toggleDrawer="drawer = !drawer"
      @showRightDrawer="rightDrawer = true"
      @getOldNotifications="getOldNotifications"
      @refreshNotificationHistory="getNotificationHistory"
      @closeWebSocket="onClose"
    />

    <!-- Side Navigation -->
    <SideNavigation v-model="drawer" />

    <!-- Side Navigation -->
    <RightDrawer v-model="rightDrawer" />

    <!-- Base Content -->
    <v-main>
      <v-container fluid class="pa-0">
        <router-view />
      </v-container>
    </v-main>
  </div>
</template>

<script>
import AppBar from "@/components/BaseComponents/AppBar.vue";
import AppFooter from "@/components/BaseComponents/AppFooter.vue";
import RightDrawer from "@/components/BaseComponents/RightDrawer.vue";
import SideNavigation from "@/components/BaseComponents/SideNavigation.vue";
import { Loader } from "@googlemaps/js-api-loader";
import LoaderScreen from "@/components/General/LoaderScreen.vue";

export default {
  components: {
    AppBar,
    SideNavigation,
    AppFooter,
    RightDrawer,
    LoaderScreen,
  },

  name: "Shipper",

  data() {
    return {
      unreadCount: 0,
      companyNotifications: [],
      userCompanyId: null,
      // Drawer vars
      drawer: false,
      rightDrawer: false,

      // Snackbar vars
      snackbar: false,
      vertical: false,
      hasActions: false,
      text: null,
      color: null,
      timeout: 2000,
      position: null,

      // Loader Var
      showOverlay: false,
    };
  },
  computed: {
    currentProfile() {
      let obj = JSON.parse(localStorage.getItem("userProfile"));
      if (!obj) {
        return {};
      } else {
        return obj;
      }
    },
  },
  methods: {
    showToastMessage(options) {
      this.snackbar = true;
      this.text = options.message;
      this.color = options.color;
      this.timeout = options.timeout;
      this.position = options.position;
    },
    showLoader(value) {
      this.showOverlay = value;
    },
    setupWS(userType) {
      if (!this.$ws.instance) {
        this.$ws.createInstance(userType);
        this.$ws.instance.onopen = this.onOpen;
      } else {
        this.onOpen();
      }
      this.$ws.instance.onmessage = this.onMessage;
    },
    getOldNotifications(refreshHistory) {
      if (refreshHistory) {
        this.getNotificationHistory();
      }
    },
    onClose() {
      this.$ws.removeInstance();
    },
    onMessage(ev) {
      if (ev && ev.data) {
        const data =
          typeof ev.data == typeof "" ? JSON.parse(ev.data) : ev.data;
        this.$bus.$emit("socketMessageReceived", data);
      }
    },
    onOpen() {
      this.getNotificationHistory();
    },
    getNotificationHistory(params = {}) {
      params = {
        company: this.currentProfile.company,
        limit: this.limit,
        offset: this.offset,
        ...params,
      };
      if (this.companyNotifications.length && !params.clearAll) {
        params.offset = this.companyNotifications.length;
      }
      this.$api.company
        .getCompanyNotifications(params)
        .then((res) => {
          if (res.additional_info) {
            this.unreadCount = res.additional_info.unread_count;
          }
          if (this.companyNotifications.length && !params.clearAll) {
            this.companyNotifications.push(...res.data);
          } else {
            this.companyNotifications = res.data;
          }
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
  },
  beforeCreate() {
    this.$bus.$emit("showLoader", true);
    this.$api.authentication
      .getProfileInfo()
      .then((res) => {
        this.$bus.$emit("showLoader", false);
        localStorage.setItem("userProfile", JSON.stringify(res.data));
        localStorage.setItem("user_type", res.data.user_type);
        const preference = res?.data?.user_preferences || {};
        localStorage.setItem("userPreferences", JSON.stringify(preference));
        localStorage.setItem(
          "permissions",
          JSON.stringify(res.data.permissions)
        );
        if (res.data) {
          this.userType = "customer";
          if (this.userType) {
            this.setupWS(this.userType);
          }
        }
      })
      .catch((err) => {
        console.error(err);
        this.$bus.$emit("showLoader", false);
      });
  },
  created() {
    this.$bus.$on("socketMessageReceived", (data) => {
      let socketDataType = null;
      if (data.type && data.type == "notification_received") {
        let newNotification = { ...data.data };
        this.unreadCount = data.data.unread_count;
        this.companyNotifications.unshift(newNotification);
      }
      if (
        this.$route &&
        this.$route.path &&
        !this.$route.path.includes("operations")
      ) {
        if (this.userType == "customer") {
          socketDataType = "message_from_transporter";
        } else if (this.userType == "transporter") {
          socketDataType = "message_from_customer";
        }
        if (
          socketDataType &&
          data.type &&
          [socketDataType].indexOf(data.type) > -1
        ) {
          this.$bus.$emit("showToastMessage", {
            message: `New message in Trip: ${data.data.trip_id} from "${data.data.company_name}"`,
            color: "blue",
            hasActions: true,
          });
        }
      }
    });
  },
  async mounted() {
    // Google map loading code
    if (window.google == undefined) {
      const loader = new Loader({
        apiKey: process.env.VUE_APP_MAP_KEY,
        version: "weekly",
        libraries: ["places", "geometry", "drawing"],
      });
      await loader.load();
    }
  },
};
</script>
